import React from 'react'
import { Bars3Icon } from '@heroicons/react/24/outline'
import { HeaderProps } from '../../../types/layout'
import { usePageTitle } from '../../../hooks/layout'
import PageTitle from './PageTitle'
import Breadcrumbs from './Breadcrumbs'
import UserMenu from './UserMenu'

/**
 * Componente principal del Header
 * Incluye título de página, breadcrumbs y menú de usuario
 */
const Header: React.FC<HeaderProps> = ({ onLogout, onMenuClick }) => {
  const { pageTitle, breadcrumbs } = usePageTitle()

  return (
    <header className="bg-white shadow-sm sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex min-h-16 items-center justify-between py-1.5 sm:py-2">
          <div className="flex items-center space-x-4">
            {/* Botón menú móvil */}
            <button
              className="lg:hidden text-gray-500 hover:text-gray-700 transition-all duration-200 hover:scale-110 active:scale-95"
              onClick={onMenuClick}
              aria-label="Abrir menú"
            >
              <Bars3Icon className="h-6 w-6" />
            </button>

            {/* Título y breadcrumbs */}
            <div>
              <PageTitle titleInfo={pageTitle} />
              <Breadcrumbs items={breadcrumbs} />
            </div>
          </div>

          {/* Menú de usuario */}
          <UserMenu onLogout={onLogout} />
        </div>
      </div>
    </header>
  )
}

export default React.memo(Header)

